module.exports = __webpack_public_path__ + "img/image (84).07ff0824.jpg";